import React, { useEffect, useState } from "react";
import { cancelpass, mypass } from "../../services/Employeeservice";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { FaBus, FaClock, FaMapMarkedAlt } from "react-icons/fa";
import { GrValidate } from "react-icons/gr";
import { parse, format, isValid } from "date-fns";
import { BsThreeDotsVertical } from "react-icons/bs";
import { toast } from "react-toastify";
import logo from "../../Images/shuttellogo.png";
import { BsSignStopFill } from "react-icons/bs";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
const Viewpass = ({ gethistorydata, setCheckpass }) => {
  const navigate = useNavigate()
  const [cancelloading, setCancelloading] = useState(false);
  const [renewloading, setRenewloading] = useState(false);
  const [pass, setPass] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuopen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlemenuClose = () => {
    setAnchorEl(null);
  };
  const [renewopen, setRenewopen] = useState(false);
  const handlerenewopen = () => setRenewopen(true);
  const handlerenewclose = () => setRenewopen(false);
  useEffect(() => {
    mypass()
      .then((res) => {
        setPass(res.data);
        setCheckpass(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handlecancelpass = () => {
    setCancelloading(true);
    cancelpass({ id: pass?.id || "" })
      .then((res) => {
        setPass(null);
        setCheckpass(false);
        gethistorydata();
        handleClose();
        toast.success("Pass Canceled successfully");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setCancelloading(false);
      });
  };
  const formatTime = (timeStr) => {
    if (!timeStr) return "N/A";
    const parsed = parse(timeStr, "HH:mm:ss", new Date());
    return isValid(parsed) ? format(parsed, "hh:mm a") : "N/A";
  };
  return (
    <div className="d-flex justify-content-center">
      <div className="col-12">
        {pass ? (
          <div
            className="card"
            style={{
              borderRadius: "10px",
              background: "linear-gradient(135deg, #3b1f1f, #5c2b29, #874f3e)",
              color: "#f8f1e5",
              // boxShadow: "0 10px 20px rgba(0, 0, 0, 0.5)",
              fontFamily: "'Segoe UI', sans-serif",
              position: "relative",
              overflow: "hidden",
              minHeight: "200px",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="d-flex justify-content-between p-2">
              <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "550",
                  letterSpacing: "0.5px",
                }}
              >
                🚍 Employee Bus Pass
              </span>
              <div className="d-flex gap-1">
                <span
                  className="d-inline-flex align-items-center gap-1 text-capitalize me-1"
                  style={{
                    minHeight: "28px",
                    fontSize: "0.875rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span
                    className="rounded-circle d-inline-block"
                    style={{
                      marginTop: "-5px",
                      width: "8px",
                      height: "8px",
                      backgroundColor:
                        pass.status.toLowerCase() === "active"
                          ? "#28a745"
                          : "#6c757d",
                    }}
                  ></span>
                  <span className="fw-semibold">
                    {pass.status.toLowerCase()}
                  </span>
                </span>
                <span
                  className="d-flex justify-content-center align-items-center bg-primary p-1 cursor-pointer"
                  style={{ borderRadius: "5px" }}
                >
                  <BsThreeDotsVertical onClick={handleClick} />
                </span>
              </div>
            </div>
            <div className="px-2 pb-3">
              <div
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                }}
              >
                {pass.employee.name}
              </div>
              <div
                className="mb-1"
                style={{ fontSize: "0.8rem", opacity: 0.8 }}
              >
                Pass ID: {pass.pass_id}
              </div>
              <div className="mb-1" style={{ fontSize: "0.95rem" }}>
                <FaMapMarkedAlt className="me-2 text-warning" />
                <strong>Route:</strong> {pass.route.name} <span className={`badge badge-lg bg-white text-primary`}>{pass.route.route_number}</span>
              </div>
              <div className="mb-1" style={{ fontSize: "0.95rem" }}>
                <BsSignStopFill className="me-2 text-warning" />
                <strong>Stop:</strong> {pass?.stop?.name}
              </div>
              <div className="mb-2" style={{ fontSize: "0.95rem" }}>
                <FaBus className="me-2 text-warning" />
                <strong>Bus:</strong> {pass.bus.number_plate} ({pass.bus.model})
              </div>
              <div className="mb-2" style={{ fontSize: "0.95rem" }}>
                <GrValidate className="me-2 text-warning" />
                <strong>Start From:</strong>{" "}
                {format(new Date(pass.start_date), "d MMMM yyyy")}
                {/* →{" "}{format(new Date(pass.end_date), "d MMMM yyyy")} */}
              </div>
              <div style={{ fontSize: "0.95rem", width: "80%" }}>
                <FaClock className="me-2 text-warning" />
                <strong>Pickup</strong>({formatTime(pass.reach_time)}) –{" "}
                <strong>Shift</strong>: {pass.shift?.name}
              </div>
            </div>
            {/* QR / Photo Placeholder */}
            <div
              style={{
                position: "absolute",
                bottom: "20px",
                right: "24px",
                width: "60px",
                height: "60px",
                backgroundColor: "#ffffff33",
                borderRadius: "8px",
                border: "1px dashed #f4e2d8",
                padding: "1.3%",
              }}
            >
              <img src={logo} />
            </div>
          </div>
        ) : (
          <div className="text-center mt-3">
            <div className="mb-2">You dont have any active pass</div>
            <Link to="/employee/booking" className="btn btn-primary">
              Apply Pass
            </Link>
          </div>
        )}
      </div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Pass Cancelation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to cancel pass.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button className="btn btn-outline-danger" onClick={handleClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handlecancelpass}>
            {cancelloading ? (
              <>
                <Spinner animation="border" size="sm" />
                <span className="ms-1">Loading...</span>
              </>
            ) : (
              "Confirm"
            )}
          </button>
        </DialogActions>
      </Dialog>
      <Dialog open={renewopen} onClose={handlerenewclose}>
        <DialogTitle>Renew Pass</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to renew pass
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button className="btn btn-outline-danger" onClick={handlerenewclose}>
            Cancel
          </button>
          <button className="btn btn-primary">Confirm</button>
        </DialogActions>
      </Dialog>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={menuopen}
        onClose={handlemenuClose}
        onClick={handlemenuClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* <MenuItem onClick={handlerenewopen}>Renew Pass</MenuItem> */}
        <MenuItem onClick={()=> navigate("/employee/passchange")}> Change Pass</MenuItem>
        <MenuItem onClick={handleOpen}>Cancel Pass</MenuItem>
      </Menu>
    </div>
  );
};

export default Viewpass;
